import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(public)/legal/terms-of-use/page.tsx");
